export default __webpack_public_path__ + "static/media/vg-search.361e87e0.svg";